export default __webpack_public_path__ + "locales/zh-CN/ChangePhoneDialog.json?hash=4c32925d145826eb61826149c7ed447a";